/**
 * Labstep
 *
 * @module components/Tree/Item
 * @desc Item (branch) in Tree
 */

import { FilterItem } from 'labstep-web/components/Filter/Item';
import { ToggleCollapse } from 'labstep-web/core/ToggleCollapse';
import { useToggle } from 'labstep-web/hooks/toggle';
import type React from 'react';
import styles from './styles.module.scss';
import type { ITreeItemProps } from './types';

export const TreeItem: React.FC<ITreeItemProps> = ({
  children,
  style,
  icon,
  cornerIcon,
  cornerIconPosition,
  text,
  active,
  onClick,
  ...rest
}) => {
  const [isToggled, toggle] = useToggle(active);
  return (
    <div style={style}>
      <div className={styles.row}>
        <div>
          <FilterItem
            icon={icon}
            cornerIcon={cornerIcon}
            cornerIconPosition={cornerIconPosition}
            text={text}
            actionShortcuts={
              children && (
                <ToggleCollapse
                  onClick={(e) => {
                    // prevent dropdown menu from closing on mobile
                    e.preventDefault();
                    e.stopPropagation();
                    toggle();
                  }}
                  isCollapsed={!isToggled}
                />
              )
            }
            active={active}
            onClick={() => {
              onClick();
              toggle();
            }}
            {...rest}
          />
        </div>
      </div>
      <div>{isToggled && children}</div>
    </div>
  );
};
